import { gql } from "@apollo/client";

import { IVRGridRow } from "Types/IVR";

export type IVRQueryResult = {
    getIvrFlows: {
        items: IVRGridRow[];
        total: number;
        page: number;
        pageSize: number;
    };
};

export const getIVRList = gql`
    query ($queryParams: QueryParams!) {
        getIvrFlows(queryParams: $queryParams) {
            items {
                id
                name
                state
            }
            total
            page
            pageSize
        }
    }
`;
